import styled from 'styled-components';

import Colours from '/shared/styled/Colours';

export default styled.div`
  padding: 1.5rem 0;
  margin: 1.5rem 0;
  border-bottom: 1px solid ${Colours.greyLight9};
`;
